export enum TaskArea {
  Reservation = 'Reservation',
  Room = 'Room'
}



// WEBPACK FOOTER //
// ./src/components/TaskManagement/domain/enums/TaskArea.ts